import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { UserDto, UserRole } from '@fleet-beat/core';
import { AuthService, CompanyStoreService, RedirectService } from '@fleet-beat/shared';

@Injectable()
export class RoleGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private companyStoreService: CompanyStoreService,
    private redirectService: RedirectService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const allowedRoles = route.data['roles'] as `${UserRole}`[];
    const redirectTo = route.data['redirectTo'] as string | undefined;
    const user: UserDto = this.authService.authUser;
    if (allowedRoles.includes(user.role)) {
      return true;
    }
    if (redirectTo && this.companyStoreService.getCompany()) {
      this.redirectService.navigate([redirectTo]);
    } else {
      this.router.navigate(['/']);
    }
    return false;
  }
}
